import apiClient from './api.service';

const CategoryService = {
  // Get all categories
  getAllCategories() {
    return apiClient.get('/base/categories');
  },

  // Get active categories
  getActiveCategories() {
    return apiClient.get('/base/activecategories');
  },

  // Create category
  createCategory(data) {
    return apiClient.post('/base/admin/category', data);
  },

  // Update category
  updateCategory(id, data) {
    return apiClient.put(`/base/admin/category/${id}`, data);
  },

  // Delete category
  deleteCategory(id) {
    return apiClient.delete(`/base/admin/category/${id}`);
  },

  // Update active categories
  updateActiveCategories(categoryIds) {
    return apiClient.post('/base/activecategories', { categories: categoryIds });
  },

  // Get all levels
  getAllLevels() {
    return apiClient.get('/base/levels');
  },

  // Create level
  createLevel(data) {
    return apiClient.post('/base/admin/level', data);
  },

  // Update level
  updateLevel(id, data) {
    return apiClient.put(`/base/admin/level/${id}`, data);
  },

  // Delete level
  deleteLevel(id) {
    return apiClient.delete(`/base/admin/level/${id}`);
  }
};

export default CategoryService;
